import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getActualConnection, getConnectionsOfUser, getCheckInConnectionsOfUser, connectionIsGyroDevice, connectionIsInGyroTrial,
  getConnectionGyroTrialSubscription
} from '../../Lib/ConnectionsUtils'
import Upgrades from '../../Components/Screens/Upgrades/Upgrades'
import styles from '../Styles/Screens'

class UpgradesScreen extends Component {

  constructor(props) {
    super(props)
    this.state = {
      userAllConnections: []
    }
  }

  goToConnectionUpgrade = (connectionId, subscription) => {
    const { _id, type } = subscription
    const connection = getActualConnection(this.props.connections, connectionId)
    const isGyro = connectionIsGyroDevice(connection)
    if (isGyro && type === 'gyro') {
      const inGyroTrial = connectionIsInGyroTrial(connection)
      const { device } = connection
      const { subscriptionStart, lastSubscriptionDate, campaign } = device || {}
      const unpaidSince = campaign?.subscription?.unpaidSince
      const subscriptionPlan = getConnectionGyroTrialSubscription(connection)

      if (unpaidSince) {
        this.props.navigation.navigate('UpgradeScreen', { connectionId, plan: subscriptionPlan, paymentFailing: true })
      } else if (subscriptionStart || inGyroTrial) {
        this.props.navigation.navigate('UpgradeScreen', { connectionId, plan: subscriptionPlan })
      } else if (lastSubscriptionDate) {
        this.props.navigation.navigate('UpgradeScreen', { connectionId, plan: { type: 'gyro' } })
      } else if (inGyroTrial) {
        this.props.navigation.navigate('UpgradeScreen', { connectionId, plan: subscriptionPlan })
      } else {
        this.props.navigation.navigate('UpgradeScreen', { connectionId, gyroTrial: true, plan: { type } })
      }
    } else {
      if (_id) {
        this.props.navigation.navigate('UpgradeScreen', { connectionId, plan: subscription })
      } else {
        this.props.navigation.navigate('UpgradeScreen', { connectionId, plan: { type } })
      }
    }
  }

  render = () => {
    const userConnections = getConnectionsOfUser(this.props.connections, this.props.userId)
    const userCheckInConnections = getCheckInConnectionsOfUser(this.props.connections, this.props.userId)
    const userAllConnections = [...userConnections, ...userCheckInConnections]
    const isEmpty = userAllConnections.length === 0
    
    return (
        <div style={{
          ...styles.mainContainer,
          display: isEmpty ? 'block' : 'flex',
          width: '100%',
          maxWidth: '800px',
        }}>
        <Upgrades
          connections={userAllConnections}
          fetching={this.props.fetching}
          onPressItem={this.goToConnectionUpgrade}
        />
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    connections: state.connections.connections,
    fetching: state.connections.fetching,
    error: state.connections.error,
    userId: state.auth.userId
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpgradesScreen)